import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{staticClass:"pa-n3",attrs:{"color":"accent","elevate-on-scroll":"","scroll-target":"#scrolling-techniques-7"}},[_c(VContainer,[_c(VRow,{staticStyle:{"font-family":"'Avenir'"},attrs:{"align":"center","justify":"center"}},[_c(VBtn,{staticClass:"mr-7",on:{"click":_vm.upgrade}},[_vm._v(_vm._s(_vm.$t('message_TopProCTA'))+" »")]),_vm._v(" "+_vm._s(_vm.proAdvantage)+" "),_c(VIcon,{staticClass:"ml-3"},[_vm._v("fa-regular fa-bolt")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }